import * as React from 'react';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

const logo = ({ inca = false }) =>
    inca ? (
        <svg width="30" height="30">
            <image
                id="nexxt-bot-logo-4"
                width="30"
                height="30"
                href={`${STATIC_STORAGE_URL}/img/inca_blue_favicon.png`}
            />
        </svg>
    ) : (
        <svg width="100" height="40">
            <image
                id="nexxt-bot-logo-4"
                width="100"
                height="40"
                href={`${STATIC_STORAGE_URL}/img/inca_logo_text.png`}
            />
        </svg>
    );

export default logo;
